import { assets } from '@/assets';
import { DIAGRAMS } from '@/content/diagrams';
import type { DiagramId } from '@/game/coach/cues';
import { MouthPicture } from '@/ui/MouthHintCard';
import { WordCueCard } from '@/ui/WordCueCard';

/**
 * Development page (`?hint=r-bunched&instead=w`): the word card showing a cue's mouth picture, as
 * the child sees it, for the blind visual review (CLAUDE.md, docs/design/visual-review.md).
 */
export function HintPreview({ shows, insteadOf }: { shows: DiagramId; insteadOf?: DiagramId }) {
  return (
    <main style={{ padding: 16, background: '#0b1a3a', minHeight: '100vh' }}>
      <div style={{ maxWidth: 420 }}>
        <WordCueCard
          id="preview"
          word="rock"
          picture={assets.objects.targetWords.rocket}
          coaching={{
            id: 'preview',
            picture: (
              <MouthPicture shows={DIAGRAMS[shows]} insteadOf={insteadOf && DIAGRAMS[insteadOf]} />
            ),
            line: 'Say the ee in see.',
            trying: null,
            onReplay: () => undefined,
          }}
        />
      </div>
    </main>
  );
}
